/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ReactDOMServer from 'react-dom/server';

import {
  LeftArrowIcon,
  RightArrowIcon,
  StarIcon,
  TwoComasIcon,
  VerifiedIcon,
} from "../../constants/icons.jsx";
import "./reviewsCard.css";
import "./responsive.css";
import Slider from "react-slick";
import axios from "axios";
import Spiner from "../../ui/spiner/spiner.jsx";
import { colors } from "../../constants/colors.js";
import { useScreenSize } from "../../hooks/index.js";
import Swal from "sweetalert2";

const mockedData = [
  {
    title: "Some One",
    content:
      "This is our second time using Jack for our real estate needs.  Jack assisted us in buying a new home and also selling our current home.  He was great throughout the whole process.  Kept us up to date on key events and also answered all questions we had about various items.  We would highly recommend Jack to anyone who is looking to buy or sell a home!",
  },
  { title: "Miguel Stapleton", content: "Wonderful agent!" },
  { title: "Taras Sivenkii", content: "Great friend!" },
  { title: "Papai", content: "Great friend!" },
  { title: "Garry", content: "Great friend!" },
  { title: "Me", content: "Just me" },
];

const ReviewsCard = ({ container }) => {
  const [isViewMore, setIsViewMore] = useState(false);
  const [isViewMore2, setIsViewMore2] = useState(false);
  const [data, setData] = useState(null);
  const [dataError, setDataError] = useState(null);
  const MySwal = Swal.mixin();
  const dataSourceUrl = container.getAttribute("data-source-url");
  const dataSourceParam = container.getAttribute("data-source-param");
  const dataLimit = container.getAttribute("data-limit");
  useEffect(() => {
    axios
      .get(
        `${dataSourceUrl}?limit=${dataLimit ? dataLimit : 3}${
          dataSourceParam ? `&${dataSourceParam}` : ""
        }`
      )
      .then(function (response) {
        setData(response.data.data);
      })
      .catch(function (error) {
        setDataError(error);
      });

    const div = document
      .getElementsByClassName("active-listings-reviews-card-wrapper")[0]
      .querySelector(".page-curl");

    if (div)
      div.addEventListener("click", function () {
        var reviewText = document.getElementById("review-text");
        reviewText.style.maxHeight = "none";
        reviewText.style.overflow = "visible";
      });
  }, []);

  const viewMoreHandler = () => {
    setIsViewMore(false);
  };

  const seeMoreReview=(item,starsArr,unfullStarsArr)=>{
    const htmlContent=
         (
             <div className="swal reviews-card-container-box">
                <div className="active-listings-reviews-card-mark-star-icons">
                    {starsArr.map((v, ind) => {
                        return (
                        <div
                            className="active-listings-reviews-card-mark-star-icon-box"
                            key={ind}
                        >
                            <StarIcon full={true} />
                        </div>
                        );
                    })}
                    {unfullStarsArr.map((v, ind) => {
                        return (
                        <div
                            className="active-listings-reviews-card-mark-star-icon-box"
                            key={ind}
                        >
                            <StarIcon full={false} />
                        </div>
                        );
                    })}
                </div>
                <div className="active-listings-reviews-card-title-block">
                    <div className="active-listings-reviews-card-title">
                        <p>{item?.clientname}</p>
                    </div>
                </div>
                <div
                    className={
                    isViewMore
                        ? "active-listings-reviews-card-content"
                        : "active-listings-reviews-card-content ellipsis-multiline"
                    }
                >
                    <span>{item?.Review}</span>
                </div>
            </div>
        );
    const componentHtml = ReactDOMServer.renderToString(htmlContent);
    MySwal?.fire({text:item?.Review,html:componentHtml})
  }

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => {
    return (
      <button
        {...props}
        className={
          "slick-arrow active-listings-reviews-card-slider-left-arrow" +
          (currentSlide === slideCount - 1 ? " slick-disabled" : "")
        }
        // aria-hidden="true"
        aria-disabled={currentSlide === 0 ? true : false}
        type="button"
        aria-label="Previous image button"
      >
        <LeftArrowIcon color={colors.mainBg} width={40} height={40} />
      </button>
    );
  };
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-arrow active-listings-reviews-card-slider-right-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
    //   aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
      aria-label="Next image button"
    >
      <RightArrowIcon color={colors.mainBg} width={40} height={40} />
    </button>
  );

  const screenSize = useScreenSize();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:
      screenSize.width < 1200 ? (screenSize.width < 769 ? 1 : 2) : 3,
    slidesToScroll: 1,
    arrows: true,
    // lazyLoad: true,
    nextArrow: <SlickArrowLeft />,
    prevArrow: <SlickArrowRight />,
  };

  return (
    <div className="active-listings-reviews-card-wrapper">
      {data && (
        <Slider {...settings}>
          {data?.map((item, ind) => {
            const starsArr = [];
            const unfullStarsArr = [];
            const unfullStarsCount = 5 - +item?.stars;
            if (+item?.stars)
              for (let i = 0; i < +item?.stars; i++) {
                starsArr.push({ star: i });
              }
            if (unfullStarsCount !== 0) {
              for (let i = 0; i < unfullStarsCount; i++) {
                unfullStarsArr.push({ star: i });
              }
            }
            return (
              <div className="active-listings-reviews-card-container" key={ind}>
                <div className="reviews-card-container-box">
                  <div className="active-listings-reviews-card-title-block">
                    <div className="active-listings-reviews-card-title">
                      <p>{item?.clientname}</p>
                    </div>
                  </div>
                  <div className="active-listings-reviews-card-mark-star-icons">
                    {starsArr.map((v, ind) => {
                      return (
                        <div
                          className="active-listings-reviews-card-mark-star-icon-box"
                          key={ind}
                        >
                          <StarIcon full={true} />
                        </div>
                      );
                    })}
                    {unfullStarsArr.map((v, ind) => {
                      return (
                        <div
                          className="active-listings-reviews-card-mark-star-icon-box"
                          key={ind}
                        >
                          <StarIcon full={false} />
                        </div>
                      );
                    })}
                  </div>
                  {/* <div class="page-curl"></div> */}
                  <div className="active-listings-reviews-card-mark-icon">
                    <TwoComasIcon />
                  </div>
                  <div
                    className={
                      isViewMore
                        ? "active-listings-reviews-card-content"
                        : "active-listings-reviews-card-content ellipsis-multiline"
                    }
                  >
                    <span>{item?.Review}</span>
                  </div>
                    <span style={{display:(item?.Review?.length>107)?"block":"none"}} onClick={()=>{seeMoreReview(item,starsArr,unfullStarsArr)}} className={"reviews-see-more"}>...more</span>
                </div>
                <>
                  <div className="active-listings-reviews-card-bottom-block-left">
                    <div>
                      <VerifiedIcon />
                    </div>
                    <div>
                      <p>verified</p>
                    </div>
                  </div>
                  {/* <div className="active-listings-reviews-card-bottom-block-right">
                  <p>View More</p>
                </div> */}
                </>
              </div>
            );
          })}
        </Slider>
      )}
      {!data && (
        <div className="active-listings-reviews-card-img-spiner">
          <Spiner />
        </div>
      )}
    </div>
  );
};

export default ReviewsCard;
